import * as TYPES from '../types'
import api from '../../api'

const state = {
  items: []
}

const mutations = {
  [TYPES.DO_GET_VERSIONS](state, data) {
    state.items = data
  }
}

const actions = {
  [TYPES.DO_CREATE_VERSION]({ commit }, data) {
    return new Promise(function (resolve, reject) {
      api
        .DO_CREATE_VERSION(data)
        .then(res => {
          if (res.data.ok) {
            resolve(res)
          } else {
            reject(res)
          }
        })
        .catch(res => {
          reject(res)
        })
    })
  },
  [TYPES.DO_GET_VERSIONS]({ commit }) {
    return new Promise(function (resolve, reject) {
      api
        .DO_GET_VERSIONS()
        .then(res => {
          if (res.data.ok) {
            commit(TYPES.DO_GET_VERSIONS, res.data.data)
            resolve(res)
          } else {
            reject(res)
          }
        })
        .catch(res => {
          reject(res)
        })
    })
  },
  [TYPES.DO_UPDATE_VERSION]({ commit, state }, data) {
    return new Promise(function (resolve, reject) {
      api
        .DO_UPDATE_VERSION(data)
        .then(res => {
          if (res.data.ok) {
            resolve(res)
          } else {
            reject(res)
          }
        })
        .catch(res => {
          reject(res)
        })
    })
  },
  [TYPES.DO_DELETE_VERSION]({ commit, state }, data) {
    return new Promise(function (resolve, reject) {
      api
        .DO_DELETE_VERSION(data)
        .then(res => {
          if (res.data.ok) {
            resolve(res)
          } else {
            reject(res)
          }
        })
        .catch(res => {
          reject(res)
        })
    })
  }
}

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/verions.js